"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractHeicMime = exports.isImageHeic = exports.isLinkMime = exports.CUSTOM_LINK_MIME = exports.isVideoMime = exports.isGifExtension = exports.isGifMime = exports.isTextMime = exports.isImageMime = exports.isAudioMime = exports.VALID_OPEN_DOC_MIME = exports.VALID_XLS_MIME = exports.VALID_IMAGE_MIME = void 0;
exports.VALID_IMAGE_MIME = "image/gif, image/jpeg, image/png, image/heic, image/heif";
exports.VALID_XLS_MIME = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, .csv, text/csv";
exports.VALID_OPEN_DOC_MIME = "application/vnd.oasis.opendocument.text, application/vnd.oasis.opendocument.spreadsheet, application/vnd.oasis.opendocument.formula";
function isAudioMime(mime) {
    // FIXME: exclude MIDI :-)
    return mime && mime.indexOf("audio") > -1;
}
exports.isAudioMime = isAudioMime;
function isImageMime(mime) {
    return mime && mime.indexOf("image") > -1;
}
exports.isImageMime = isImageMime;
function isTextMime(mime) {
    return mime && mime.indexOf("text") === 0;
}
exports.isTextMime = isTextMime;
function isGifMime(mime) {
    return isGifExtension(mime === null || mime === void 0 ? void 0 : mime.split("image/")[1]);
}
exports.isGifMime = isGifMime;
function isGifExtension(ext) {
    return ext && ["gif", "webp", "webm"].includes(ext);
}
exports.isGifExtension = isGifExtension;
function isVideoMime(mime) {
    return mime && mime.indexOf("video") > -1;
}
exports.isVideoMime = isVideoMime;
exports.CUSTOM_LINK_MIME = "application/x-mx-link";
function isLinkMime(mime) {
    return mime && mime === exports.CUSTOM_LINK_MIME;
}
exports.isLinkMime = isLinkMime;
function isImageHeic(fileName) {
    if (!fileName) {
        return false;
    }
    return fileName.toLowerCase().endsWith(".heic") || fileName.toLowerCase().endsWith(".heif");
}
exports.isImageHeic = isImageHeic;
function extractHeicMime(fileName) {
    if (isImageHeic(fileName)) {
        return `image/${fileName.substr(fileName.length - 4).toLowerCase()}`;
    }
    return "";
}
exports.extractHeicMime = extractHeicMime;
//# sourceMappingURL=mimeHelper.js.map